import React, {Fragment, useContext, useEffect, useState} from 'react';
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import SiteInfoQuestions from 'components/sales/formSection/siteInfo/siteInfo';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const ChecklistQuestions = ({
                                documentUploadUrl,
                                match,
                                location,
                                pmChecklistQues,
                                pmSoftwareAnswer,
                                fetchPmQues,
                                pmSoftwareAnswerResponse=[]
                            }) => {


    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [isFiled, setIsFiled] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [formData, setFormData] = useState(null);
    const [docVal, setDocVal] = useState(null);

    const handleModalHide = () => setIsModal(false);

    useEffect(() => {
        if (fetchPmQues !== null)
            (async () => {
                if (match?.params?.id) {
                    setIsLoading(true);
                    await fetchPmQues(match?.params?.id, 0, 1);
                    setIsLoading(false);
                }
            })();
    }, []);

    const handleFormVal = (val) => {
        setFormData(val);
    };
    const headerBtns = () => {
        return (
            <Fragment>
                <Button onClick={handleSubmit} className="btn btn-primary">
                    {localization.submitDtl}
                    <img src={Images?.ArrowRight} alt="" />
                </Button>
            </Fragment>
        );
    };

    console.log(pmSoftwareAnswerResponse)
    const handleSubmit = async () => {
        if (formData === null) {
            setIsFiled(true);
            setIsModal(false);
        } else {
            setIsFiled(true);
            await (async () => {
                setIsLoading(true);
                const res = await pmSoftwareAnswer({
                    ...formData,
                    docs: docVal,
                    schedule_id:match?.params?.schedule_id
                });
                setIsLoading(false);
                if (res === true) {
                    setIsModal(true);
                }
            })();
        }
    };

    return (
        <Layout
            title={localization.pendingTask}
            className={isFiled && 'requiredFileds'}
            Buttons={headerBtns}
            isGoback
            isLoading={isLoading}
            linkUrl={`${baseUrl}/view-pm-list/${match?.params?.id}/${match?.params?.manageId}`}
        >
            <div>
                <FileUpload
                    id="agreementContractUpload"
                    accept=".pdf,.png,.jpg"
                    documentUploadUrl={documentUploadUrl}
                    onChange={(val) => setDocVal(val)}
                >
              <span className="btn btn-transparent">
                {localization.uploadDocs}
              </span>
                </FileUpload>
            </div>
            <SiteInfoQuestions
                className={isFiled && 'requiredFileds'}
                data={pmChecklistQues}
                handleValue={handleFormVal}
                documentUploadUrl={documentUploadUrl}
                match={match}
                location={location}
            />
            <ModalPop
                title={localization.conf}
                show={isModal}
                handleModalHide={handleModalHide}
                keyboard
                backdrop
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>{localization.preB2bSuccess}</h5>
                    <Link
                        to={`${baseUrl}/pm-software-sites`}
                        className="btn btn-primary mb-4"
                    >
                        {localization.viewPmList} <img src={Images?.ArrowRight} alt="" />
                    </Link>
                </div>
            </ModalPop>
        </Layout>
    );
}

export default ChecklistQuestions